import React from 'react';
import commonUtil from '../../../utils/commonUtil';

const constChannels = commonUtil.getClientConstForChannel();
const channel = commonUtil.getChannel();
class NavigationBar extends React.Component {
  render() {
    const props = this.props;
    const _tabs = props.tabs;
    const { tabSelected, selectedTheme } = props;

    const color700 = selectedTheme?.color_700 ?? '#242424';
    const color50 = selectedTheme?.color_50 ?? '#EBEBEB';

    const tabsHtml = _tabs.map((tab, index) => {
      const isSelected = tab.id === tabSelected;
      let anchorHTML = (<a id={'tab' + tab.id} className={tab.enabled} href={'#' + tab.id} dangerouslySetInnerHTML={{ __html: tab.label }} />);
      if (tab.enabled === 'disabled') {
        anchorHTML = (<a id={'tab' + tab.id} className={tab.enabled} dangerouslySetInnerHTML={{ __html: tab.label }} />);
      }

      return (
        <React.Fragment key={'tab' + index}>
          <li
            key={'tabIndex' + index}
            style={{ color: color700, borderBottomColor: color700 }}
          >
            {anchorHTML}
            {/* Uncomment below if you want to show notifications
            {tab.notifification && tab.notifification !== '0' ? (
              <span className={channel === constChannels.WAP ? 'newRecievedGifts' : 'activeNotification'}>
                {tab.notifification}
              </span>
            ) : null} */}
          </li>
        </React.Fragment>
      );
    });
    return (
      <div>
        <ul id="tabs" className="navigation-bar-tabs">
          {tabsHtml}
        </ul>
        {
          <div className="navigation-bar-selected" style={{ color: color700, backgroundColor: color50 }}>
            {tabSelected && (
              <span>
                {
                  (tabSelected == 'summary') ? (_tabs.find(tab => tab.id === tabSelected)?.newLabel) : (_tabs.find(tab => tab.id === tabSelected)?.label) || ''
                }
              </span>
            )}
          </div>
        }
      </div>
    );
  }
}

export default NavigationBar;
